import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusValidation } from 'src/app/store/answers-store';

@Component({
    selector: 'que-error-message',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorMessageComponent {
  statusValidation = StatusValidation;

  error: StatusValidation = StatusValidation.Error;

  constructor(
    private dialogRef: MatDialogRef<ErrorMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { error: StatusValidation }
  ) {
    this.error = data?.error ?? StatusValidation.Error;
  }

  close(): void {
    this.dialogRef.close();
  }
}